import React from 'react';

const BusinessCardExport = () => {
  // Real QR code using QR Server API - generates scannable QR for mushongasystems.com/free-review
  // Size increased for reliable scanning from printed card
  const qrCodeUrl = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://mushongasystems.com/free-review&bgcolor=ffffff&color=000000&qzone=2&format=png";

  return (
    <div className="min-h-screen bg-neutral-950 flex flex-col items-center justify-start gap-10 py-10 px-8">
      <div className="text-center">
        <h1 className="text-white text-xl font-semibold mb-2">Mushonga Systems — Business Card</h1>
        <p className="text-neutral-500 text-sm">85mm × 55mm • 300 DPI • CMYK Ready • Matte Finish • Square Corners</p>
      </div>
      
      {/* ==================== FRONT CARD ==================== */}
      <div className="flex flex-col items-center">
        <p className="text-neutral-600 text-xs uppercase tracking-widest mb-3">Front</p>
        <div 
          id="front-card"
          style={{
            width: '510px',
            height: '330px',
            background: '#0a0a0a',
            position: 'relative',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
            overflow: 'hidden'
          }}
        >
          {/* Subtle corner glow - premium effect */}
          <div style={{
            position: 'absolute',
            top: '-60px',
            right: '-60px',
            width: '220px',
            height: '220px',
            background: 'radial-gradient(circle, rgba(16, 185, 129, 0.08) 0%, transparent 70%)',
            pointerEvents: 'none'
          }} />
          
          {/* Top accent line */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '120px',
            height: '3px',
            background: 'linear-gradient(90deg, #10B981, #059669)'
          }} />
          
          {/* Content */}
          <div style={{ 
            padding: '28px 36px 24px 36px', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between',
            position: 'relative',
            zIndex: 1
          }}>
            
            {/* TOP - Company Brand (PRIMARY FOCUS - 40% larger logo, 20% larger text) */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '6px' }}>
                <img 
                  src="/mushonga_logo_circular.png"
                  alt="Mushonga Systems"
                  style={{ width: '67px', height: '67px' }}
                />
                <div>
                  <h1 style={{ 
                    color: 'white', 
                    fontSize: '34px', 
                    fontWeight: '700', 
                    margin: 0, 
                    letterSpacing: '-0.5px',
                    lineHeight: 1
                  }}>
                    MUSHONGA SYSTEMS
                  </h1>
                  <p style={{ 
                    color: '#10B981', 
                    fontSize: '9px', 
                    margin: '8px 0 0 0', 
                    letterSpacing: '2px',
                    fontWeight: '600',
                    textTransform: 'uppercase'
                  }}>
                    Modern Websites • Automation • CRM Systems
                  </p>
                </div>
              </div>
            </div>
            
            {/* MIDDLE - Contact Person (SECONDARY - improved spacing) */}
            <div style={{ 
              borderLeft: '2px solid #10B981',
              paddingLeft: '16px',
              marginLeft: '4px',
              marginTop: '8px'
            }}>
              <p style={{ 
                color: '#ffffff', 
                fontSize: '17px', 
                fontWeight: '600', 
                margin: 0,
                letterSpacing: '0.3px'
              }}>
                Adam Mushonga
              </p>
              <p style={{ 
                color: '#6b7280', 
                fontSize: '11px', 
                margin: '4px 0 0 0',
                fontWeight: '500',
                letterSpacing: '0.3px'
              }}>
                Automation & Web Systems Specialist
              </p>
            </div>
            
            {/* BOTTOM - Contact Details (Enhanced readability) */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              marginTop: '16px',
              paddingTop: '16px',
              borderTop: '1px solid rgba(255,255,255,0.06)'
            }}>
              {/* Left - Primary contacts (larger, more readable) */}
              <div style={{ display: 'flex', gap: '32px' }}>
                {/* Email - Most prominent */}
                <div>
                  <p style={{ color: '#4b5563', fontSize: '9px', letterSpacing: '1.5px', margin: '0 0 5px 0', textTransform: 'uppercase', fontWeight: '600' }}>Email</p>
                  <p style={{ color: 'white', fontSize: '14px', fontWeight: '600', margin: 0 }}>adam@mushongasystems.com</p>
                </div>
                {/* Phone */}
                <div>
                  <p style={{ color: '#4b5563', fontSize: '9px', letterSpacing: '1.5px', margin: '0 0 5px 0', textTransform: 'uppercase', fontWeight: '600' }}>Phone</p>
                  <p style={{ color: '#e5e5e5', fontSize: '14px', fontWeight: '500', margin: 0, whiteSpace: 'nowrap' }}>07539 249987</p>
                </div>
              </div>
              
              {/* Right - Website (enhanced visibility) */}
              <div style={{ textAlign: 'right' }}>
                <p style={{ color: '#4b5563', fontSize: '9px', letterSpacing: '1.5px', margin: '0 0 5px 0', textTransform: 'uppercase', fontWeight: '600' }}>Web</p>
                <p style={{ color: '#d4d4d4', fontSize: '13px', fontWeight: '500', margin: 0 }}>mushongasystems.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== BACK CARD ==================== */}
      <div className="flex flex-col items-center">
        <p className="text-neutral-600 text-xs uppercase tracking-widest mb-3">Back</p>
        <div 
          id="back-card"
          style={{
            width: '510px',
            height: '330px',
            background: '#0a0a0a',
            position: 'relative',
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
            display: 'flex',
            overflow: 'hidden'
          }}
        >
          {/* Left accent stripe */}
          <div style={{
            width: '4px',
            background: 'linear-gradient(180deg, #10B981 0%, #059669 100%)',
            flexShrink: 0
          }} />
          
          {/* Left content area */}
          <div style={{ 
            flex: 1, 
            padding: '24px 20px 20px 20px', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between'
          }}>
            {/* Top - Value Proposition (SIGNIFICANTLY LARGER) */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
                <img 
                  src="/mushonga_logo_circular.png"
                  alt="Logo"
                  style={{ width: '20px', height: '20px', opacity: 0.9 }}
                />
                <span style={{ color: '#6b7280', fontSize: '9px', fontWeight: '700', letterSpacing: '1.2px' }}>MUSHONGA SYSTEMS</span>
              </div>
              
              {/* Value Proposition - Much larger text */}
              <p style={{ 
                color: '#ffffff', 
                fontSize: '15px', 
                fontWeight: '500', 
                margin: '0 0 16px 0',
                lineHeight: 1.5,
                maxWidth: '280px'
              }}>
                Helping businesses save time, reduce admin and scale through smart systems.
              </p>
              
              {/* Services - Compact 2 columns */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 14px' }}>
                {[
                  'Real Client Deployments',
                  'Business Automation',
                  'Booking Platforms',
                  'Custom Software',
                  'Websites & Portals',
                  'CRM Systems',
                  'AI Workflows'
                ].map((service, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <div style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      background: 'rgba(16, 185, 129, 0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    <span style={{ color: '#9ca3af', fontSize: '9px', fontWeight: '500' }}>{service}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Bottom - Trust Indicators + Closing */}
            <div>
              {/* Trust Indicators - Prominent */}
              <div style={{ 
                display: 'flex',
                gap: '16px',
                marginBottom: '12px',
                paddingTop: '12px',
                borderTop: '1px solid rgba(255,255,255,0.05)'
              }}>
                {[
                  { icon: '✓', text: 'Real Deployments' },
                  { icon: '✓', text: 'Local UK Business' },
                  { icon: '★', text: '5.0 Google Rating' }
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ color: '#10B981', fontSize: '9px', fontWeight: '700' }}>{item.icon}</span>
                    <span style={{ color: '#6b7280', fontSize: '8px', fontWeight: '600' }}>{item.text}</span>
                  </div>
                ))}
              </div>
              
              {/* Closing Message - More prominent */}
              <p style={{ 
                color: '#10B981', 
                fontSize: '11px', 
                margin: 0,
                fontWeight: '700',
                letterSpacing: '0.5px'
              }}>
                Real systems. Real clients. Real results.
              </p>
            </div>
          </div>
          
          {/* Right - QR Code Section (Improved messaging) */}
          <div style={{ 
            width: '155px', 
            background: 'linear-gradient(180deg, rgba(16, 185, 129, 0.03) 0%, rgba(16, 185, 129, 0.08) 100%)',
            borderLeft: '1px solid rgba(16, 185, 129, 0.15)',
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '16px 12px'
          }}>
            {/* Benefit-first headline */}
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              <p style={{ 
                color: '#10B981', 
                fontSize: '8px', 
                fontWeight: '800', 
                textTransform: 'uppercase', 
                letterSpacing: '0.8px',
                margin: 0,
                lineHeight: 1.3
              }}>
                Free Website &
              </p>
              <p style={{ 
                color: '#10B981', 
                fontSize: '8px', 
                fontWeight: '800', 
                textTransform: 'uppercase', 
                letterSpacing: '0.8px',
                margin: '2px 0 0 0',
                lineHeight: 1.3
              }}>
                Systems Review
              </p>
            </div>
            
            {/* Real QR Code - Larger for reliable scanning */}
            <div style={{ 
              background: 'white', 
              padding: '8px', 
              borderRadius: '8px', 
              marginBottom: '10px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
            }}>
              <img 
                src={qrCodeUrl}
                alt="QR Code - Scan for free review at mushongasystems.com/free-review"
                style={{ 
                  width: '100px', 
                  height: '100px',
                  display: 'block'
                }}
              />
            </div>
            
            {/* Scan Here CTA */}
            <p style={{ 
              color: 'white', 
              fontSize: '10px', 
              fontWeight: '600', 
              margin: 0, 
              textAlign: 'center',
              letterSpacing: '0.3px'
            }}>
              Scan Here
            </p>
            <p style={{ 
              color: '#6b7280', 
              fontSize: '7px', 
              margin: '4px 0 0 0', 
              textAlign: 'center',
              letterSpacing: '0.2px'
            }}>
              mushongasystems.com
            </p>
          </div>
        </div>
      </div>

      {/* ==================== DESK MOCKUP ==================== */}
      <div className="flex flex-col items-center mt-6">
        <p className="text-neutral-600 text-xs uppercase tracking-widest mb-3">Mockup Preview</p>
        <div 
          style={{
            width: '800px',
            height: '420px',
            background: 'linear-gradient(160deg, #141414 0%, #0a0a0a 50%, #171717 100%)',
            borderRadius: '12px',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0,0,0,0.6)'
          }}
        >
          {/* Surface texture */}
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.3) 100%)'
          }} />
          
          {/* Cards */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            gap: '40px'
          }}>
            {/* Front card mockup */}
            <div style={{
              width: '300px',
              height: '194px',
              background: '#0a0a0a',
              transform: 'perspective(1200px) rotateY(-8deg) rotateX(5deg)',
              boxShadow: '0 25px 50px -15px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.05)',
              position: 'relative'
            }}>
              <div style={{ position: 'absolute', top: 0, left: 0, width: '70px', height: '2px', background: 'linear-gradient(90deg, #10B981, #059669)' }} />
              <div style={{ padding: '16px 20px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <img src="/mushonga_logo_circular.png" style={{ width: '38px', height: '38px' }} alt="" />
                  <div>
                    <p style={{ color: 'white', fontSize: '18px', fontWeight: '700', margin: 0, letterSpacing: '-0.3px' }}>MUSHONGA SYSTEMS</p>
                    <p style={{ color: '#10B981', fontSize: '5px', margin: '4px 0 0 0', letterSpacing: '1.2px', fontWeight: '600' }}>MODERN WEBSITES • AUTOMATION • CRM SYSTEMS</p>
                  </div>
                </div>
                <div style={{ borderLeft: '2px solid #10B981', paddingLeft: '10px' }}>
                  <p style={{ color: '#ffffff', fontSize: '10px', fontWeight: '600', margin: 0 }}>Adam Mushonga</p>
                  <p style={{ color: '#6b7280', fontSize: '7px', margin: '2px 0 0 0' }}>Automation & Web Systems Specialist</p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', paddingTop: '8px', borderTop: '1px solid rgba(255,255,255,0.04)' }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div>
                      <p style={{ color: '#4b5563', fontSize: '5px', letterSpacing: '1px', margin: '0 0 2px 0' }}>EMAIL</p>
                      <p style={{ color: 'white', fontSize: '8px', fontWeight: '600', margin: 0 }}>adam@mushongasystems.com</p>
                    </div>
                    <div>
                      <p style={{ color: '#4b5563', fontSize: '5px', letterSpacing: '1px', margin: '0 0 2px 0' }}>PHONE</p>
                      <p style={{ color: '#e5e5e5', fontSize: '8px', margin: 0 }}>07539 249987</p>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p style={{ color: '#4b5563', fontSize: '5px', letterSpacing: '1px', margin: '0 0 2px 0' }}>WEB</p>
                    <p style={{ color: '#d4d4d4', fontSize: '7px', margin: 0 }}>mushongasystems.com</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Back card mockup */}
            <div style={{
              width: '300px',
              height: '194px',
              background: '#0a0a0a',
              transform: 'perspective(1200px) rotateY(8deg) rotateX(5deg)',
              boxShadow: '0 25px 50px -15px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.05)',
              display: 'flex'
            }}>
              <div style={{ width: '3px', background: 'linear-gradient(180deg, #10B981, #059669)' }} />
              <div style={{ flex: 1, padding: '14px 12px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '8px' }}>
                    <img src="/mushonga_logo_circular.png" style={{ width: '12px', height: '12px', opacity: 0.8 }} alt="" />
                    <span style={{ color: '#6b7280', fontSize: '5px', fontWeight: '700', letterSpacing: '0.8px' }}>MUSHONGA SYSTEMS</span>
                  </div>
                  <p style={{ color: '#ffffff', fontSize: '8px', fontWeight: '500', margin: '0 0 8px 0', lineHeight: 1.4, maxWidth: '160px' }}>
                    Helping businesses save time, reduce admin and scale through smart systems.
                  </p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3px 8px' }}>
                    {['Real Deployments', 'Automation', 'Booking', 'Software', 'Websites', 'CRM', 'AI'].map((s, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <svg width="5" height="5" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="4"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        <span style={{ color: '#9ca3af', fontSize: '5px' }}>{s}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '6px', paddingTop: '6px', borderTop: '1px solid rgba(255,255,255,0.04)' }}>
                    {['✓ Real', '✓ Local UK', '★ 5.0'].map((t, i) => (
                      <span key={i} style={{ color: '#6b7280', fontSize: '5px', fontWeight: '600' }}>{t}</span>
                    ))}
                  </div>
                  <p style={{ color: '#10B981', fontSize: '6px', margin: 0, fontWeight: '700' }}>Real systems. Real clients. Real results.</p>
                </div>
              </div>
              <div style={{ width: '85px', borderLeft: '1px solid rgba(16, 185, 129, 0.15)', background: 'rgba(16, 185, 129, 0.05)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
                <p style={{ color: '#10B981', fontSize: '5px', fontWeight: '800', textTransform: 'uppercase', margin: '0 0 4px 0', textAlign: 'center', letterSpacing: '0.5px' }}>Free Website &<br/>Systems Review</p>
                <div style={{ background: 'white', padding: '4px', borderRadius: '4px', marginBottom: '4px' }}>
                  <img src={qrCodeUrl} alt="QR" style={{ width: '52px', height: '52px', display: 'block' }} />
                </div>
                <p style={{ color: 'white', fontSize: '6px', fontWeight: '600', margin: 0, textAlign: 'center' }}>Scan Here</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* QR Code Validation */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-lg p-4 max-w-md text-center">
        <p className="text-emerald-400 text-xs font-semibold uppercase tracking-wider mb-2">QR Code Validation</p>
        <p className="text-neutral-400 text-xs mb-2">Target URL:</p>
        <code className="text-white text-xs bg-neutral-800 px-2 py-1 rounded">https://mushongasystems.com/free-review</code>
        <p className="text-neutral-500 text-xs mt-3">
          ✓ Real QR code generated via api.qrserver.com<br/>
          ✓ 300×300px source for print quality<br/>
          ✓ Links to live Free Review landing page
        </p>
      </div>

      {/* Print specs */}
      <div className="text-center mt-4">
        <p className="text-neutral-700 text-xs">
          Print: 85mm × 55mm • 300 DPI • CMYK Safe • Matte Finish • Square Corners • 3mm Bleed
        </p>
        <p className="text-neutral-600 text-xs mt-2">
          Screenshot each card individually at 100% zoom for print-ready PNG exports
        </p>
        <p className="text-neutral-500 text-xs mt-1">
          Use browser print-to-PDF for PDF output
        </p>
      </div>
    </div>
  );
};

export default BusinessCardExport;
